<app-progress></app-progress>
<mat-card class="w-full">
    <mat-card-header>
      <mat-card-title>
        <img alt="SmartPart Edge" class="logo-login mb-2" mat-card-image ngSrc="./assets/app-logo.svg" height="117"
             width="659">
      </mat-card-title>
        <mat-card-subtitle>Enter your email to get password reset instructions</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form (submit)="requestNewPassword()" [formGroup]="form" class="form">
        <mat-form-field class="form-field-full-width">
          <input class="form-group" formControlName="email" matInput placeholder="Enter your email"
            required type="text">
          @if (form.get('email').hasError('required')) {
            <mat-error>Email is required</mat-error>
          }
          @if (form.get('email').hasError('email')) {
            <mat-error>Invalid email</mat-error>
          }
        </mat-form-field>
        @if (globalErrorMessage) {
          <mat-error>
            {{globalErrorMessage}}
          </mat-error>
        }
          <div class="flex items-center justify-center gap-2">
          @if (displayLoginButton) {
            <button [routerLink]="['/login']" color="primary" mat-raised-button
              type="button">Return To Login
            </button>
          }
          <button [disabled]="form.invalid" color="primary" mat-raised-button type="submit">Submit</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
